// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { Auth } from 'aws-amplify';
import React, { ComponentPropsWithRef, useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';
import { uploadFile } from '../apis/base';
import { getMe, updateMe } from '../apis/member';
import { clearRunningLabAction, updateRunningLabAction } from '../redux/actionCreators/runningLabAction';
import { clearRunningChallengeAction, updateRunningChallengeAction } from '../redux/actionCreators/runningChallengeAction';
import { clearRunningExamAction, updateRunningExamAction } from '../redux/actionCreators/runningExamAction';
import { DEFAULT_MEMBER, Member, UpdateMember } from '../types/Model';
import { loadContext, removeContext, saveContext, UpdatableContext, cognitoClear } from './utils';

const LOCALSTORAGE_KEY = 'MemberContext';

interface MemberContextType extends Member, UpdatableContext {
  isLogin: boolean;
  isBifrostLogin: boolean,
  setIsBifrostLogin: (status: boolean) => void;
  removeCognito: () => void;
}

const defaultValue: Member = DEFAULT_MEMBER;

const MemberContext = React.createContext<MemberContextType>({
  ...defaultValue,
  update: (data?: UpdateMember) => console.log('MemberContext update no update'),
  clear: () => removeContext(LOCALSTORAGE_KEY),
  isLogin: false,
  isLoading: false,
  isBifrostLogin: loadContext('isBifrostLogin', true),
  setIsBifrostLogin: (status: boolean) => {},
  removeCognito: () => cognitoClear()
})

export const MemberContextProvider = (props: ComponentPropsWithRef<'div'>): JSX.Element => {
  const [state, setState] = useState<Member & { isLogin: boolean, isBifrostLogin?: boolean }>({
    isLogin: false,
    isBifrostLogin: loadContext('isBifrostLogin', true),
    ...loadContext(LOCALSTORAGE_KEY, defaultValue),
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isBifrostLogin, setBifrostLogin] = useState(loadContext('isBifrostLogin', true));
  const dispatch = useDispatch();

  const update = useCallback(async (data?: UpdateMember) => {
    const cognitoKey = localStorage.getItem('CognitoKey');
    const idToken = localStorage.getItem(`${cognitoKey}.idToken`)
    const auth = await Auth.currentAuthenticatedUser().catch(() => undefined);

    if (!auth && !idToken) {
      setState({
        ...defaultValue,
        isLogin: false,
      })
      removeContext(LOCALSTORAGE_KEY);
      cognitoClear();
      return;
    }

    setIsLoading(true);
    if (data) {
      if (data.imageUrl) {
        const { fileName, upload } = await uploadFile(data.imageUrl);
        console.log({ fileName, upload });
        await updateMe({ ...data, imageUrl: fileName })
      } else {
        await updateMe(data)
      }
    }
    await getMe()
      .then((member) => {
        if (member.runningLab) {
          dispatch(updateRunningLabAction(member.runningLab));
        } else {
          dispatch(clearRunningLabAction());
        }
        if (member.runningChallenge) {
          dispatch(updateRunningChallengeAction(member.runningChallenge));
        } else {
          dispatch(clearRunningChallengeAction());
        }
        if (member.runningExam) {
          dispatch(updateRunningExamAction(member.runningExam));
        } else {
          dispatch(clearRunningExamAction());
        }
        const memberContext = {
          ...member,
          isLogin: true,
        };
        setState(memberContext)
        saveContext(LOCALSTORAGE_KEY, memberContext);
      })
      .catch(() => {
        clear()
      })
    setIsLoading(false);
  }, [setState, setIsLoading]);

  const clear = useCallback(async () => {
    removeContext(LOCALSTORAGE_KEY);
    cognitoClear();
    setState({
      ...defaultValue,
      isLogin: false,
    });
  }, [setState]);

  const removeCognito = (async () => {
    removeContext(LOCALSTORAGE_KEY);
    removeContext('isBifrostLogin');
    removeContext('homeInfoRemind');
    cognitoClear();
  });

  const setIsBifrostLogin = (status: boolean) => {
    setBifrostLogin(status);
    saveContext('isBifrostLogin', status);
    saveContext('homeInfoRemind', status);
  }

  const value = useMemo(() => {
    return {
      ...state,
      isLoading,
      isBifrostLogin,
      setIsBifrostLogin,
      clear,
      update,
      removeCognito,
    }
  }, [state, isLoading, clear, update])

  return (
    <MemberContext.Provider value={value}>
      {(props.children)}
    </MemberContext.Provider>
  )
}

export default MemberContext;
